import { projectsOverviewAPI } from "@/views/ProjectsOverview/services/api";

export const getProjectsCommonInfo = async (params) => {
  try {
    const res = await projectsOverviewAPI.getProjectsCommonInfo(params);
    return res?.data || [];
  } catch (e) {}
};
export const getResidentialsList = async () => {
  try {
    const res = await projectsOverviewAPI.getResidentials();
    return res?.data || [];
  } catch (e) {}
};
export const getProjectTypes = async (resident_id) => {
  const params = { resident_id };
  try {
    const res = await projectsOverviewAPI.getProjectTypes(params);
    return res?.data || [];
  } catch (e) {}
};

export const projectsOverviewColumns = [
  {
    name: "resident_name",
    label: "ЖК",
    field: "resident_name",
    align: "left",
    sortable: true,
    headerStyle: "min-width: 160px",
    style: "min-width: 160px",
  },
  {
    name: "project_type_name",
    label: "Тип проекта",
    field: "project_type_name",
    align: "left",
    sortable: true,
  },
  {
    name: "entrances",
    label: "Подъезды",
    field: "entrances",
    align: "center",
    sortable: true,
  },
  {
    name: "flats",
    label: "Количество квартир",
    field: "flats",
    align: "center",
    sortable: true,
  },
  {
    name: "total_sum",
    label: "Сумма проекта",
    field: "total_sum",
    align: "right",
    sortable: true,
  },
  {
    name: "status",
    label: "Статус",
    field: "status",
    align: "center",
    sortable: true,
    headerStyle: "width: 160px",
    style: "width: 160px",
  },
  {
    name: "payment_sum",
    label: "Сумма оплаты",
    field: "payment_sum",
    align: "right",
    sortable: true,
  },
  {
    name: "percentage_of_payment",
    label: "Готовность по оплате %",
    field: "percentage_of_payment",
    align: "center",
    sortable: true,
  },
  {
    name: "floor_percentage",
    label: "Готовность по этажам %",
    field: "floor_percentage",
    align: "center",
    sortable: true,
  },
];
